"use client";
import { j as d } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as me } from "./tv.config-BuYIgndg.mjs";
import * as t from "react";
import Q from "react";
import xe from "./Typography.js";
import { c as Ce } from "./createLucideIcon-BjO0sRuo.mjs";
import { u as De } from "./useControlled-B2rPEZCb.mjs";
import { u as K } from "./useEventCallback-CjuAhyNz.mjs";
import { I as he, F as Re, a as be, u as ye } from "./useScrollLock-COQT0_go.mjs";
import { a as Z, u as Ne } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { u as Ee } from "./useOpenInteractionType-CFukK4P5.mjs";
import { u as ve, a as Oe, b as ke, t as Pe } from "./translateOpenChangeReason-C857LgAi.mjs";
import { u as Ie } from "./useFloatingRootContext-BSTWPoxk.mjs";
import { g as we } from "./element-DE7VsBMX.mjs";
import { u as A } from "./useButton-CQeWQM5o.mjs";
import { u as y, m as _e, c as ee, C as je } from "./useRenderElement-B8V3_e8R.mjs";
import { p as te, C as B, t as Se } from "./popupStateMapping-Cl0RMVD6.mjs";
import { F as Me } from "./FloatingPortal-B6chGyBH.mjs";
import { t as oe } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { i as Te } from "./inertValue-CseOXFGF.mjs";
import { C as Be } from "./composite-D7hKyvC5.mjs";
import { u as ne } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as se } from "./useBaseUiId-a-UPSsPQ.mjs";
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fe = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Ve = Ce("x", Fe), F = /* @__PURE__ */ t.createContext(void 0);
process.env.NODE_ENV !== "production" && (F.displayName = "DialogContext");
const V = /* @__PURE__ */ t.createContext(void 0);
process.env.NODE_ENV !== "production" && (V.displayName = "DialogRootContext");
function Ue() {
  const e = t.useContext(V), o = t.useContext(F);
  if (!(o === void 0 && e === void 0))
    return {
      ...e,
      ...o
    };
}
function b() {
  const e = t.useContext(V), o = t.useContext(F);
  if (o === void 0)
    throw new Error("Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>.");
  return {
    ...e,
    ...o
  };
}
const Ge = {
  ...te,
  ...oe
}, ie = /* @__PURE__ */ t.forwardRef(function(o, a) {
  const {
    render: p,
    className: l,
    forceRender: i = !1,
    ...u
  } = o, {
    open: s,
    nested: r,
    mounted: n,
    transitionStatus: c,
    backdropRef: f
  } = b(), g = t.useMemo(() => ({
    open: s,
    transitionStatus: c
  }), [s, c]);
  return y("div", o, {
    state: g,
    ref: [f, a],
    customStyleHookMapping: Ge,
    props: [{
      role: "presentation",
      hidden: !n,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, u],
    enabled: i || !r
  });
});
process.env.NODE_ENV !== "production" && (ie.displayName = "DialogBackdrop");
function He(e) {
  const {
    open: o,
    setOpen: a,
    disabled: p,
    nativeButton: l
  } = e, i = K((n) => {
    o && a(!1, n.nativeEvent, "close-press");
  }), {
    getButtonProps: u,
    buttonRef: s
  } = A({
    disabled: p,
    native: l
  });
  return {
    getRootProps: (n) => _e({
      onClick: i
    }, n, u),
    ref: s
  };
}
const ae = /* @__PURE__ */ t.forwardRef(function(o, a) {
  const {
    render: p,
    className: l,
    disabled: i = !1,
    nativeButton: u = !0,
    ...s
  } = o, {
    open: r,
    setOpen: n
  } = b(), {
    getRootProps: c,
    ref: f
  } = He({
    disabled: i,
    open: r,
    setOpen: n,
    nativeButton: u
  }), g = t.useMemo(() => ({
    disabled: i
  }), [i]);
  return y("button", o, {
    state: g,
    ref: [a, f],
    props: [s, c]
  });
});
process.env.NODE_ENV !== "production" && (ae.displayName = "DialogClose");
const re = /* @__PURE__ */ t.forwardRef(function(o, a) {
  const {
    render: p,
    className: l,
    id: i,
    ...u
  } = o, {
    setDescriptionElementId: s
  } = b(), r = se(i);
  return ne(() => (s(r), () => {
    s(void 0);
  }), [r, s]), y("p", o, {
    ref: a,
    props: [{
      id: r
    }, u]
  });
});
process.env.NODE_ENV !== "production" && (re.displayName = "DialogDescription");
function Ke(e) {
  const {
    descriptionElementId: o,
    initialFocus: a,
    mounted: p,
    openMethod: l,
    ref: i,
    setPopupElement: u,
    titleElementId: s
  } = e, r = t.useRef(null), n = ee(i, r, u), c = t.useCallback((m) => m === "touch" ? r : 0, []), f = t.useMemo(() => a == null ? c(l ?? "") : typeof a == "function" ? a(l ?? "") : a, [c, a, l]);
  return {
    popupProps: {
      "aria-labelledby": s ?? void 0,
      "aria-describedby": o ?? void 0,
      role: "dialog",
      tabIndex: -1,
      ref: n,
      hidden: !p,
      onKeyDown(m) {
        Be.has(m.key) && m.stopPropagation();
      }
    },
    resolvedInitialFocus: f
  };
}
let Le = /* @__PURE__ */ function(e) {
  return e.nestedDialogs = "--nested-dialogs", e;
}({}), We = function(e) {
  return e[e.open = B.open] = "open", e[e.closed = B.closed] = "closed", e[e.startingStyle = B.startingStyle] = "startingStyle", e[e.endingStyle = B.endingStyle] = "endingStyle", e.nested = "data-nested", e.nestedDialogOpen = "data-nested-dialog-open", e;
}({});
const L = /* @__PURE__ */ t.createContext(void 0);
process.env.NODE_ENV !== "production" && (L.displayName = "DialogPortalContext");
function ze() {
  const e = t.useContext(L);
  if (e === void 0)
    throw new Error("Base UI: <Dialog.Portal> is missing.");
  return e;
}
const Xe = {
  ...te,
  ...oe,
  nestedDialogOpen(e) {
    return e ? {
      [We.nestedDialogOpen]: ""
    } : null;
  }
}, le = /* @__PURE__ */ t.forwardRef(function(o, a) {
  const {
    className: p,
    finalFocus: l,
    initialFocus: i,
    render: u,
    ...s
  } = o, {
    descriptionElementId: r,
    dismissible: n,
    floatingRootContext: c,
    getPopupProps: f,
    modal: g,
    mounted: m,
    nested: D,
    nestedOpenDialogCount: P,
    open: C,
    openMethod: U,
    popupRef: I,
    setPopupElement: G,
    titleElementId: w,
    transitionStatus: _,
    onOpenChangeComplete: h,
    internalBackdropRef: H
  } = b();
  ze(), Z({
    open: C,
    ref: I,
    onComplete() {
      C && (h == null || h(!0));
    }
  });
  const j = ee(a, I), {
    popupProps: S,
    resolvedInitialFocus: M
  } = Ke({
    descriptionElementId: r,
    initialFocus: i,
    mounted: m,
    openMethod: U,
    ref: j,
    setPopupElement: G,
    titleElementId: w
  }), T = P > 0, N = t.useMemo(() => ({
    open: C,
    nested: D,
    transitionStatus: _,
    nestedDialogOpen: T
  }), [C, D, _, T]), E = y("div", o, {
    state: N,
    props: [f(), S, {
      style: {
        [Le.nestedDialogs]: P
      }
    }, s],
    customStyleHookMapping: Xe
  });
  return /* @__PURE__ */ d.jsxs(t.Fragment, {
    children: [m && g === !0 && /* @__PURE__ */ d.jsx(he, {
      ref: H,
      inert: Te(!C)
    }), /* @__PURE__ */ d.jsx(Re, {
      context: c,
      disabled: !m,
      closeOnFocusOut: n,
      initialFocus: M,
      returnFocus: l,
      modal: g !== !1,
      children: E
    })]
  });
});
process.env.NODE_ENV !== "production" && (le.displayName = "DialogPopup");
function Ye(e) {
  const {
    children: o,
    keepMounted: a = !1,
    container: p
  } = e, {
    mounted: l
  } = b();
  return l || a ? /* @__PURE__ */ d.jsx(L.Provider, {
    value: a,
    children: /* @__PURE__ */ d.jsx(Me, {
      root: p,
      children: o
    })
  }) : null;
}
function $e(e) {
  const {
    defaultOpen: o,
    dismissible: a,
    modal: p,
    onNestedDialogClose: l,
    onNestedDialogOpen: i,
    onOpenChange: u,
    open: s,
    onOpenChangeComplete: r
  } = e, [n, c] = De({
    controlled: s,
    default: o,
    name: "DialogRoot",
    state: "open"
  }), f = t.useRef(null), g = t.useRef(null), m = t.useRef(null), [D, P] = t.useState(void 0), [C, U] = t.useState(void 0), [I, G] = t.useState(null), [w, _] = t.useState(null), {
    mounted: h,
    setMounted: H,
    transitionStatus: j
  } = Ne(n), {
    openMethod: S,
    triggerProps: M,
    reset: T
  } = Ee(n), N = K((x, k, R) => {
    u == null || u(x, k, R), c(x);
  }), E = K(() => {
    H(!1), r == null || r(!1), T();
  });
  Z({
    enabled: !e.actionsRef,
    open: n,
    ref: f,
    onComplete() {
      n || E();
    }
  }), t.useImperativeHandle(e.actionsRef, () => ({
    unmount: E
  }), [E]);
  const v = Ie({
    elements: {
      reference: I,
      floating: w
    },
    open: n,
    onOpenChange: (x, k, R) => {
      N(x, k, Pe(R));
    }
  }), [O, W] = t.useState(0), z = O === 0, pe = be(v), fe = ve(v), ge = Oe(v, {
    outsidePressEvent: "intentional",
    outsidePress(x) {
      if (x.button !== 0)
        return !1;
      const k = we(x);
      if (z && a) {
        const R = k;
        return p ? R ? m.current === R || g.current === R : !1 : !0;
      }
      return !1;
    },
    escapeKey: z
  });
  ye({
    enabled: n && p === !0,
    mounted: h,
    open: n,
    referenceElement: w
  });
  const {
    getReferenceProps: X,
    getFloatingProps: Y
  } = ke([pe, fe, ge]);
  t.useEffect(() => (i && n && i(O), l && !n && l(), () => {
    l && n && l();
  }), [n, l, i, O]);
  const $ = t.useCallback((x) => {
    W(x + 1);
  }, []), q = t.useCallback(() => {
    W(0);
  }, []), J = t.useMemo(() => X(M), [X, M]);
  return t.useMemo(() => ({
    modal: p,
    setOpen: N,
    open: n,
    titleElementId: D,
    setTitleElementId: P,
    descriptionElementId: C,
    setDescriptionElementId: U,
    onNestedDialogOpen: $,
    onNestedDialogClose: q,
    nestedOpenDialogCount: O,
    openMethod: S,
    mounted: h,
    transitionStatus: j,
    triggerProps: J,
    getPopupProps: Y,
    setTriggerElement: G,
    setPopupElement: _,
    popupRef: f,
    backdropRef: g,
    internalBackdropRef: m,
    floatingRootContext: v
  }), [p, N, n, D, C, $, q, O, S, h, j, J, Y, v]);
}
const ce = function(o) {
  const {
    children: a,
    defaultOpen: p = !1,
    dismissible: l = !0,
    modal: i = !0,
    onOpenChange: u,
    open: s,
    actionsRef: r,
    onOpenChangeComplete: n
  } = o, c = Ue(), f = $e({
    open: s,
    defaultOpen: p,
    onOpenChange: u,
    modal: i,
    dismissible: l,
    actionsRef: r,
    onOpenChangeComplete: n,
    onNestedDialogClose: c == null ? void 0 : c.onNestedDialogClose,
    onNestedDialogOpen: c == null ? void 0 : c.onNestedDialogOpen
  }), g = !!c, m = t.useMemo(() => ({
    ...f,
    nested: g,
    onOpenChangeComplete: n
  }), [f, g, n]), D = t.useMemo(() => ({
    dismissible: l
  }), [l]);
  return /* @__PURE__ */ d.jsx(F.Provider, {
    value: m,
    children: /* @__PURE__ */ d.jsx(V.Provider, {
      value: D,
      children: a
    })
  });
};
process.env.NODE_ENV !== "production" && (ce.displayName = "DialogRoot");
const de = /* @__PURE__ */ t.forwardRef(function(o, a) {
  const {
    render: p,
    className: l,
    id: i,
    ...u
  } = o, {
    setTitleElementId: s
  } = b(), r = se(i);
  return ne(() => (s(r), () => {
    s(void 0);
  }), [r, s]), y("h2", o, {
    ref: a,
    props: [{
      id: r
    }, u]
  });
});
process.env.NODE_ENV !== "production" && (de.displayName = "DialogTitle");
const ue = /* @__PURE__ */ t.forwardRef(function(o, a) {
  const {
    render: p,
    className: l,
    disabled: i = !1,
    nativeButton: u = !0,
    ...s
  } = o, {
    open: r,
    setTriggerElement: n,
    triggerProps: c
  } = b(), f = t.useMemo(() => ({
    disabled: i,
    open: r
  }), [i, r]), {
    getButtonProps: g,
    buttonRef: m
  } = A({
    disabled: i,
    native: u
  });
  return y("button", o, {
    state: f,
    ref: [m, a, n],
    props: [c, {
      [je]: ""
    }, s, g],
    customStyleHookMapping: Se
  });
});
process.env.NODE_ENV !== "production" && (ue.displayName = "DialogTrigger");
const qe = me({
  slots: {
    root: ["Dialog__root"],
    backdrop: [
      "Dialog__backdrop",
      "fixed inset-0",
      "bg-black/30",
      "transition-all",
      "duration-150",
      "data-[ending-style]:opacity-0",
      "data-[starting-style]:opacity-0",
      "backdrop-blur"
    ],
    popup: [
      "Dialog__popup",
      "max-h-[calc(100%-3rem)]",
      "overflow-hidden",
      "fixed",
      "top-1/2",
      "left-1/2",
      "w-[calc(100%-3rem)]",
      "-translate-x-1/2",
      "-translate-y-1/2",
      "rounded-2xl",
      "bg-common-white",
      "p-6",
      "text-gray-900",
      "outline-none",
      "transition-all",
      "duration-150",
      "data-[ending-style]:scale-90",
      "data-[ending-style]:opacity-0",
      "data-[starting-style]:scale-90",
      "data-[starting-style]:opacity-0",
      "flex flex-col"
    ],
    title: ["Dialog__title", "-mt-1.5"],
    description: ["Dialog__description", "flex-1"],
    actions: [
      "Dialog__actions",
      "flex",
      "justify-end",
      "gap-4",
      "absolute",
      "top-2",
      "right-2"
    ],
    closeButton: [
      "flex size-10 items-center justify-center rounded-2xl  bg-transparent  text-base font-medium text-primary-main select-none hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-100"
    ]
  },
  variants: {
    maxWidth: {
      xs: {
        popup: ["max-w-screen-xs"]
      },
      sm: {
        popup: ["max-w-screen-sm"]
      },
      md: {
        popup: ["max-w-screen-md"]
      },
      lg: {
        popup: ["max-w-screen-lg"]
      },
      xl: {
        popup: ["max-w-screen-xl"]
      }
    },
    scrollabel: {
      true: {
        title: "p-6 pb-4",
        description: ["p-6"]
      }
    },
    disableGutters: {
      true: ["p-0"],
      false: ["p-6"]
    }
  },
  defaultVariants: {
    maxWidth: "sm",
    disableGutters: !1
  }
}), {
  root: Et,
  backdrop: Je,
  popup: Qe,
  title: vt,
  description: Ze,
  actions: Ae,
  closeButton: et
} = qe(), Ot = (e) => {
  const {
    className: o,
    children: a,
    maxWidth: p,
    title: l,
    open: i,
    onOpenChange: u,
    triggerRender: s = /* @__PURE__ */ d.jsx("button", {}),
    triggerText: r = "View notifications",
    scrollable: n
  } = e;
  return /* @__PURE__ */ d.jsxs(ce, { open: i, onOpenChange: u, children: [
    typeof i > "u" && /* @__PURE__ */ d.jsx(
      ue,
      {
        render: (c) => s ? Q.isValidElement(s) ? Q.cloneElement(s, c) : typeof s == "function" ? s(c, { disabled: !1, open: !1 }) : /* @__PURE__ */ d.jsx("button", {}) : /* @__PURE__ */ d.jsx("button", {}),
        children: r
      }
    ),
    /* @__PURE__ */ d.jsxs(Ye, { children: [
      /* @__PURE__ */ d.jsx(ie, { className: Je({}) }),
      /* @__PURE__ */ d.jsxs(
        le,
        {
          className: Qe({
            class: o,
            maxWidth: p,
            disableGutters: n
          }),
          children: [
            l && /* @__PURE__ */ d.jsx("div", { className: "flex justify-between items-center", children: /* @__PURE__ */ d.jsx(
              de,
              {
                render: /* @__PURE__ */ d.jsx(xe, { variant: "h3", children: l })
              }
            ) }),
            /* @__PURE__ */ d.jsx(
              re,
              {
                render: /* @__PURE__ */ d.jsx("div", {}),
                className: Ze({
                  scrollabel: n,
                  class: "max-h-[calc(100vh-200px)] overflow-y-auto scroll-smooth  [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
                }),
                children: a
              }
            ),
            /* @__PURE__ */ d.jsx("div", { className: Ae(), children: /* @__PURE__ */ d.jsx(ae, { className: et(), children: /* @__PURE__ */ d.jsx(Ve, {}) }) })
          ]
        }
      )
    ] })
  ] });
};
export {
  Ot as default
};
